import { Select } from 'AWS-UI-Components-React';
import React from 'react';
import logger from '../../utils/logging';
import { getJSClient } from '../js_client';

// Mock data used as fallback when backend is not deployed
const MOCK_BRANCHES = [
  { id: 'branch-fulfillment-q1-2026', domainId: 'AmazonStores', description: 'Fulfillment Fees Q1 2026', state: 'DRAFT' },
  { id: 'branch-shipping-update', domainId: 'AmazonStores', description: 'Shipping Costs Update', state: 'DRAFT' },
  { id: 'branch-inbound-rework', domainId: 'AmazonStores', description: 'Inbound Transportation Rework', state: 'DRAFT' },
  { id: 'branch-returns-q2', domainId: 'AmazonStores', description: 'Returns Processing Q2', state: 'IN_REVIEW' },
];

export class BcmBranchSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      branches: [],
      loading: true,
      error: null,
    };
  }

  componentDidMount() {
    this.fetchBranches();
  }

  fetchBranches = () => {
    const client = getJSClient();
    if (!client || !client.client) {
      // Client not ready yet — retry after a short delay
      setTimeout(() => this.fetchBranches(), 500);
      return;
    }
    client.listBcmBranches(
      (response) => {
        const branches = response.branches || [];
        const options = branches.map((branch) => ({
          id: branch.id,
          label: branch.description || branch.id,
        }));
        this.setState({ branches: options, loading: false });
        logger.info(`Loaded ${options.length} BCM branches from API`);
      },
      (error) => {
        logger.error('Failed to load BCM branches from API, falling back to mock data', error);
        // Fallback to mock data if API is not available
        const options = MOCK_BRANCHES.map((branch) => ({
          id: branch.id,
          label: branch.description || branch.id,
        }));
        this.setState({ branches: options, loading: false, error: 'Using cached branch data' });
      }
    );
  };

  onBranchSelected = (event) => {
    const selectedId = event.detail.selectedOption ? event.detail.selectedOption.id : null;
    if (this.props.onBranchChange) {
      this.props.onBranchChange(selectedId);
    }
  };

  render() {
    return (
      <Select
        placeholder="BCM Branch (optional)"
        filteringType="auto"
        filteringLabel="Filter branches"
        enableFiltering
        options={this.state.branches}
        onChange={this.onBranchSelected}
        selectedId={this.props.selectedBranchId}
        loading={this.state.loading}
        data-cy="bcm-branch-selector"
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/mapper/bcm_branch_selector.jsx